import createBrowserHistory from 'history/lib/createBrowserHistory';
import {useRouterHistory} from 'react-router';
import {getClientState} from '../config';
import {objectToQueryString} from './utils';

const historyList = [];

let history = {};

function addToHistory(e) {
  const appPage = /.+\/(overview|demo|features|reviews|developer)/;

  if (e.pathname !== '/categories/' && !appPage.test(e.pathname) && e.pathname + e.search !== historyList[0]) {
    historyList.unshift(e.pathname + e.search);
  }
}

/**
 * Create history for react router
 * @param basename {string}
 * @return {object}
 */
export function createHistory(basename) {
  history = useRouterHistory(createBrowserHistory)({basename});

  history.listen(addToHistory);
  addToHistory(history.getCurrentLocation());
  return history;
}

/**
 * Simple change url API
 * @param url {string}
 */
export function historyPush(url) {
  history.push(url);
}

/**
 * Params to add to query - optional
 * @return {string}
 */
export function getLinkQueryString(params = {}) {
  const linkQuery = getClientState().mode.linkQuery;
  const query = objectToQueryString(Object.assign({}, linkQuery, params));
  return query.length ? `?${query}` : '';
}


export function navigateBack(fromPopup) {
  let url;
  const homeUrl = getClientState().mode.market === 'standalone' ? '/main' : '/';

  if (fromPopup && historyList.length) {
    url = `${historyList[0]}`;

  } else if (!fromPopup && historyList.length > 2) {
    url = `${historyList[1]}`;

  } else {
    url = `${homeUrl}${getLinkQueryString()}`;
  }

  historyList.shift();
  historyPush(url);
}




// WEBPACK FOOTER //
// ./services/history.js